import Link from 'next/link';
import { SearchStateProps } from '@/redux/store/reducer/searchReducer';
import { memo } from 'react';
import styles from './SearchFooter.module.scss';
import Accordion from '@/components/UI/accordion/Accordion';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import SearchBreadcrumb from './searchBreadcrumb/SearchBreadcrumb';
import Divider from '@/components/UI/divider/Divider';
interface FooterProps {
  region_data: SearchStateProps['region_data'];
  url: string;
}
const SearchFooter = ({
  region_data,
  url
}: FooterProps) => {
  return <Box className={styles['search-footer-container']} data-sentry-element="Box" data-sentry-component="SearchFooter" data-sentry-source-file="SearchFooter.tsx">
      <SearchBreadcrumb region_data={region_data} data-sentry-element="SearchBreadcrumb" data-sentry-source-file="SearchFooter.tsx" />
      <Box className={styles['search-footer-main-content']} data-sentry-element="Box" data-sentry-source-file="SearchFooter.tsx">
        <Typography component="h2" className={styles['search-footer-title']} variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="SearchFooter.tsx">
          {region_data?.title}
        </Typography>
        <Box className={styles['search-footer-description']} dangerouslySetInnerHTML={{
        __html: region_data?.description as string
      }} data-sentry-element="Box" data-sentry-source-file="SearchFooter.tsx" />
      </Box>
      {Number(region_data?.faqs?.length) > 0 && <Box className={styles['faq-container']}>
          <Typography component="h2" className={styles['faq-title']} variant="bodyL_Bold">
            سوالات متداول
          </Typography>
          {region_data?.faqs?.map((item: any, index: any) => {
        return <Accordion className={styles['faq-item']} key={'FAQ_ITEM_' + index}>
                <Accordion.Title className={styles['accordion-summary-section']}>
                  <Typography variant="bodyM_Bold" color={'neutral_main'} className={styles['question-text']} component="h3">
                    {item.question}
                  </Typography>
                </Accordion.Title>
                <Accordion.Content>
                  <Box className={styles['content-wrapper']}>
                    <Divider />
                    <Typography color={'neutral_main'} variant="bodyM" component="p">
                      {item.answer}
                    </Typography>
                  </Box>
                </Accordion.Content>
              </Accordion>;
      })}
        </Box>}
      <Box component="nav" className={styles['main-link-section']} data-sentry-element="Box" data-sentry-source-file="SearchFooter.tsx">
        {region_data?.tags?.map(item => {
        let mainLink = `${url?.split('?')[0]}`;
        if (item.link) {
          mainLink += `?${item.link}`;
        }
        if (item?.link?.includes('/')) {
          mainLink = `${url.split('?')[0]}${item.link}`;
        }
        const hostname = `${url?.split('/search')[0]}`;
        if (item?.link === 'cottage=1') {
          mainLink = hostname + `/all-cottage`;
        }
        if (item?.link === 'boomgardi=1') {
          mainLink = hostname + `/all-boomgardi`;
        }
        return <Link href={mainLink} passHref key={item.link}>
              <Box className={styles['main-link-item']}>{item.name}</Box>
            </Link>;
      })}
      </Box>
    </Box>;
};
export default memo(SearchFooter);